import * as types from './type';


const initialState = {
    agents: ''
};



export default function agentReducer(state = initialState, action) {

  switch (action.type) {
      
    case types.GET_AGENTS: {
      if (action.payload && action.payload.data) {
        return {
          ...state,
          agents: action.payload.data
        }
      } else {
        return {
          ...state,
          suggestedLocation: ''
        }
      }
    }
    default: {
      return {
        ...state
      };
    }
    
  }

}